import { AppControllerType, AppRoutes } from '@/common/interfaces';
import { DynamicDomainsApiBreadcrumb } from '@/modules/AppBreadcrumb';

import { DomainsApiCloudflareController } from './cloudflare.controller';
import { DomainsApiSearchConsoleController } from './searchConsole.controller';

export const DomainsApiController: AppControllerType = {
  common: [
    {
      path: AppRoutes.DomainsApi + '/*',
      breadcrumb: DynamicDomainsApiBreadcrumb.DynamicDomainsApiListBreadcrumb
    },
    ...DomainsApiCloudflareController.common,
    ...DomainsApiSearchConsoleController.common
  ],
  drawer: [
    ...DomainsApiCloudflareController.drawer,
    ...DomainsApiSearchConsoleController.drawer
  ]
};
